<template>
  <div v-if="info_page.status_page=='preview'" id="preview-page">   
    <!-- <header-section :title='"Preview"'></header-section> -->
    <div class="section-header" >
      <loading-modal v-if="show_loading_data"></loading-modal>
      <div class="content-header row">
        <button class="btn pull-left col-md-2" @click="$parent.set_status('input')">Sửa lại</button>
        <h3 class="title col-md-8">Preview</h3>
        <button class="btn pull-right col-md-2" @click="register_counselor_api">Gửi đi</button>
      </div>
    </div>
    <info-counselor v-bind:info_page="info_page"></info-counselor>
  </div>
</template>
<script>
  import InfoCounselor from '../Counselor/InfoCounselor.vue';
  import LoadingModal from '../Modal/LoadingModal.vue';
  import router from '../../../router.js';
  var url = process.env.API_URL + process.env.API_VERSION;
  export default{
    components: {
      InfoCounselor,
      LoadingModal
    },
    props: ['info_page'],    
    data: function(){
      return {
        show_loading_data: false
      }
    },
    created: function(){      
    },
    methods:{      
// && typeof(this.info_page.user_info[key])
      register_counselor_api: function(){
        var formData = new FormData();
        formData.append('avatar_file', this.info_page.user_info['avatar_file']);
        formData.append('email', this.info_page.user_info['email']);
        // for (var key in this.info_page.user_info){          
        //   formData.append(key, this.info_page.user_info[key]);  

          
          // if (typeof(this.info_page.user_info[key]) == 'string'){
          //   formData.set(key, this.info_page.user_info[key])
          // }else if( typeof(this.info_page.user_info[key]) == 'object'){
              
            // if (key == 'avatar_file'){
            //   formData.append(key, this.info_page.user_info[key])  
            // }else{
            //   for (var ele in this.info_page.user_info[key]){
            //     // formData.append(key[ele], this.info_page.user)
            //   }
            // }
            
          // }else{
          //   continue;
          // }
        // }
        // formData.append('params_test', [1, 2, 3]);
        // console.log(typeof(this.info_page.user_info['degree']));
        // console.log(formData);
        // console.log(this.info_page.user_info)
        this.show_loading_data = true
        this.$http
          .post(
            url + '/users/register_counselor',
            this.info_page.user_info,
            { headers: 
              { 
                'Access-Control-Allow-Origin': '*',
                // 'Accept': 'application/json',multipart/form-data
                'Content-type': 'application/json'           
              } 
            }
          )
          .then((response) =>{
            // alert(response.data.message)
            this.$http
              .post(
                url + '/users/change_avatar',
                formData,
                { 
                  headers: 
                  { 
                    'Access-Control-Allow-Origin': '*',
                    'Content-type': 'multipart/form-data'           
                  } 
                }
              )
              .then((response) => {
                this.show_loading_data = false           
                alert('Tạo tài khoản thành công');
                router.push('/thank-counselor')
              })
              .catch((error) =>{
                this.show_loading_data = false;
                alert('Không cập nhật được avatar');
                // console.log(error);
              })
          })
          .catch((error) => {
            // alert(error.response);
            // alert()
            this.show_loading_data = false
            if (error.response != undefined){
              // console.log(error.response.data.message);
              alert(error.response.data.message);
            }else{
              alert('Đăng ký không thành công')
            }
          });
    }
  },    
  };
</script>
<style lang="scss" scoped>
  @import "./preview"
</style>


// WEBPACK FOOTER //
// src/views/components/RegisterPage/Preview.vue